module.exports = "/packs/images/navigation/starter-kit-7034d78c07acaabfb1bc118b05ac2293.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/starter-kit.jpg
// module id = 1820
// module chunks = 0